$(document).ready(function(){
//$(window).on('load', function(){  

  //document.addEventListener('DOMContentLoaded', () => {
    
    $('#gallery-car').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true
    });
  
    $('#activity-car').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true
    });
    
    $('#wyg-car').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: true,
      dots: false,
      infinite: false,
      responsive: [{
        breakpoint: 750,
        settings: {
          dots: true,
          arrows: false,
        }
      }]
    });
  
  //});
  
  function start_slick(){
    $('#related-products-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true,
    });
  }
  
  //window.setTimeout( start_slick, 2000 );
  
  function isInViewport(element) {
    var bounding = element.getBoundingClientRect();
    if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    ) {
        return true;
    } else {
        return false;
    }
  }
  
  //window.addEventListener('scroll', function (event) {

    //var yml = document.getElementById("yml")
    //if (isInViewport(yml)) {
      //start_slick();
    //}
  //}, false);

  $("#headingOne").on("click", function() {
    $("#collapseOne").slideToggle(200);
  });
  $("#headingThree").on("click", function() {
    $("#collapseThree").slideToggle(200);
  });

  $("#variant_header").on("click", function() {
    $("#variant_body").toggle(1, function() {
      if($(this).is(":hidden")){
        $("#variant_header").removeClass( "its-open" );
      }
      else{
        $("#variant_header").addClass( "its-open" );
      }
    });
  });



  

});




